@if (authorized$ | async) {
  <div class="d-none" data-test-id="feature-flag-is-authorized"></div>
}
@if (initialized$ | async) {
  <div class="d-none" data-test-id="feature-flag-is-initialized"></div>
}
